<section id="dynamic-category-header-2345674" class="dynamic-header-background editable">
    <div class="header-layout-9 mobile-view-container">
        <div class="desktop-header-main-container">
            @if (isSearchOverlay && headerData.searchIcon.isVisibleOnDesktop) {
            <div class="search-drop-down-container" (click)="toggleSearchDropDown()">
                <div class="search-drop-down dynamic-header-background" (click)="$event.stopPropagation()">
                    <h5 class="dynamic-header-text-color">Start your amazing search :</h5>
                    <button class="close-btn" (click)="toggleSearchDropDown()">
                        <img src="https://assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/close-line-icon.png" />
                    </button>
                    <base-search-bar [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay"></base-search-bar>
                </div>
            </div>
            }

            <!--  side menu for mobile -->
            @if (isHamburgerMenu && isMobile() && headerData.menuListVisibleOnMobile) {
            <div appClickOutside #changeHeaderMobileElement class="hamburger-menu-container" (click)="toggleHamburgerMenu()">
                <div class="hamburger-menu mobile-category-panel" (click)="$event.stopPropagation()">
                    <static-menu-collapse (hideMenu$)="toggleHamburgerMenu()" [headerData]="headerData"></static-menu-collapse>

                    @if (
                    (dynamicHeaderInline() && layoutType() === 'inlineLayout1') ||
                    (dynamicHeaderHover() && layoutType() === 'hoverLayout1')
                    ) {
                    <webstore-dynamic-menu-collapse #dynamicCategoryHeaderMobile [categories]="category || []" [menuCollapseIcon]="headerData.menuCollapseIcon" (hideMenu$)="toggleHamburgerMenu()"></webstore-dynamic-menu-collapse>
                    }
                </div>
            </div>
            }

            <div class="header-menu">
                <div class="combine-container">
                    <div class="logo-hamburger-wrapper">
                        @if (isMobile() && headerData.menuListVisibleOnMobile) {
                        <img (click)="toggleHamburgerMenu()" class="hamburger-btn header-hamburger-icon" [src]="headerData.hamburgerMenuIcon" />
                        }
                        @if (headerData.logo.isVisibleOnMobile && isMobile()) {
                        <a class="logo" [routerLink]="['/']">
                            <img class="header-logo-icon" [src]="headerData.logo.logoSrc" />
                        </a>
                        } @else {
                        @if (headerData.logo.isVisibleOnDesktop && isDesktop()) {
                        <a class="logo" [routerLink]="['/']">
                            <img class="header-logo-icon" [src]="headerData.logo.logoSrc" />
                        </a>
                        }
                        }
                    </div>

                    <!-- desktop navigation menu -->
                    @if (headerData.menuListVisibleOnDesktop) {
                    <nav #changeHeaderElement class="navigation-wrapper mega-menu-category dynamic-menu-alignment">
                        <ul class="navigation-list static-nav">
                            @for (staticMenu of headerData.menuItems; track staticMenu.id) {
                            @if (staticMenu.text !== 'Category Header') {
                            <li class="editable static-menu">
                                <a [ngClass]="{
                          'hover-color-active': showActiveColor && currentMenuId === staticMenu.id,
                          'hover-color-inactive': !showActiveColor && currentMenuId === staticMenu.id,
                        }" [id]="staticMenu.id" class="static-header dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu" [target]="staticMenu.target" [attr.data-click_action_value]="staticMenu['data-click_action_value']" [attr.data-click_action_choice]="staticMenu['data-click_action_choice']">
                                    {{ staticMenu.text }}
                                </a>

                                @if (staticMenu.subMenu?.length) {
                                <div (mouseenter)="showActiveColor = true; currentMenuId = staticMenu.id" (mouseleave)="removeHoverStyle()" class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                                    @for (subMenu of staticMenu.subMenu; track subMenu.id) {
                                    <ul class="submenu">
                                        <li>
                                            <a (click)="onLinkClick()" [id]="subMenu.id" [target]="subMenu.target" [attr.data-click_action_value]="subMenu['data-click_action_value']" [attr.data-click_action_choice]="subMenu['data-click_action_choice']" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu static-header">
                                                {{ subMenu.text }}
                                            </a>
                                        </li>
                                        @for (subSubMenu of subMenu.subMenu; track subSubMenu.id) {
                                        <li>
                                            <a (click)="onLinkClick()" [id]="subSubMenu.id" [target]="subSubMenu.target" [attr.data-click_action_value]="subSubMenu['data-click_action_value']" [attr.data-click_action_choice]="subSubMenu['data-click_action_choice']" class="sub-sub-menu-hover dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu static-header">
                                                {{ subSubMenu.text }}
                                            </a>
                                        </li>
                                        }
                                    </ul>
                                    }
                                </div>
                                }
                            </li>
                            }
                            }

                            <div class="dynamic-header" #dynamicCategoryHeader>
                                @if (dynamicHeaderInline() && layoutType() === 'inlineLayout1') {
                                @for (parentCategory of category; track parentCategory.id) {
                                <li>
                                    <a [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" [ngClass]="{
                            'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                            'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                          }" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color hoverMenu">
                                        {{ parentCategory.name }}
                                    </a>

                                    @if (parentCategory.sub_categories.length) {
                                    <div (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()" class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                                        @if (parentCategory.category_images) {
                                        <div class="category-banner">
                                            <img [src]="parentCategory.category_images" />
                                        </div>
                                        }
                                        @for (childCategory of parentCategory.sub_categories; track childCategory.id) {
                                        <ul class="submenu">
                                            <li>
                                                <a [routerLink]="'category/' + childCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: childCategory.url_path }" (click)="onLinkClick()" class="dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                                    {{ childCategory.name }}
                                                </a>
                                            </li>

                                            @for (subCategory of childCategory.sub_categories; track subCategory.id) {
                                            <li>
                                                <a [routerLink]="'category/' + subCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: subCategory.url_path }" (click)="onLinkClick()" class="sub-sub-menu-hover dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                                    {{ subCategory.name }}
                                                </a>
                                            </li>
                                            }
                                        </ul>
                                        }
                                    </div>
                                    }
                                </li>
                                }
                                }
                                @if (dynamicHeaderHover() && layoutType() === 'hoverLayout1') {
                                <li>
                                    <a (click)="onLinkClick()" class="dynamic-header-font-size dynamic-header-font-weight dynamic-header-text-color dynamic-header-hover-text-color hoverMenu">
                                        {{ headerData.categoryMenuName }}
                                    </a>

                                    @if (category) {
                                    <div class="submenu-container hide-sub-menu-header dynamic-sub-menu-background">
                                        @for (parentCategory of category; track parentCategory.id) {
                                        <ul class="submenu">
                                            <li>
                                                <a [ngClass]="{
                                    'hover-color-active': showActiveColor && currentMenuId === parentCategory.id,
                                    'hover-color-inactive': !showActiveColor && currentMenuId === parentCategory.id,
                                  }" [routerLink]="'category/' + parentCategory.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: parentCategory.url_path }" (click)="onLinkClick()" class="title dynamic-header-sub-menu-text-color dynamic-font-size-sub-menu dynamic-font-weight-sub-menu hoverSubMenu">
                                                    {{ parentCategory.name }}
                                                </a>
                                            </li>

                                            @if (parentCategory.sub_categories.length) {
                                            @for (list of parentCategory.sub_categories; track list.id) {
                                            <li (mouseenter)="showActiveColor = true; currentMenuId = parentCategory.id" (mouseleave)="removeHoverStyle()">
                                                <a (click)="onLinkClick()" [routerLink]="'category/' + list.url_path" [queryParams]="{ utm_source: 'menu', utm_medium: list.url_path }" class="sub-sub-menu-hover dynamic-header-sub-sub-menu-text-color dynamic-font-size-sub-sub-menu dynamic-font-weight-sub-sub-menu hoverSubMenu">
                                                    {{ list.name }}
                                                </a>
                                            </li>
                                            }
                                            }
                                        </ul>
                                        }
                                    </div>
                                    }
                                </li>
                                }
                            </div>
                        </ul>
                    </nav>
                    }
                </div>

                <div class="operation-button-container">
                    <!-- Desktop search Icon -->
                    @if (headerData.searchIcon.isVisibleOnDesktop && isDesktop()) {
                    <base-search-bar class="search-bar-width search-bar-desktop-display" [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay"></base-search-bar>
                    }

                    <div class="icons-main-container">
                        <!-- mobile account/cart icons -->
                        <div class="mobile-account-icon-container">
                            @if (headerData.accountIcon.isVisibleOnMobile && isMobile()) {
                            <a [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']" (click)="isHamburgerMenu = false" class="operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius header-account-indicator">
                                <img class="header-account-icon header-account-indicator" [src]="headerData.accountIcon.accountIconSrc" />
                            </a>
                            } @else {
                            @if (headerData.accountIcon.isVisibleOnDesktop && isDesktop()) {
                            <a [target]="headerData.accountIcon.target" [attr.data-click_action_value]="headerData.accountIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.accountIcon['data-click_action_choice']" class="operation-button dynamic-quick-icon-background dynamic-quick-icon-border-color dynamic-quick-icon-border-radius header-account-indicator">
                                <img class="header-account-icon header-account-indicator" [src]="headerData.accountIcon.accountIconSrc" />
                            </a>
                            }
                            }
                            @if (headerData.cartIcon.isVisibleOnMobile && isMobile()) {
                            <a (click)="isHamburgerMenu = false" class="operation-button cart-btn dynamic-quick-icon-background header-cart-indicator dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                                <img class="header-cart-icon header-cart-indicator" [src]="headerData.cartIcon.cartIconSrc" />
                                <span class="cart-count header-cart-indicator dynamic-cart-count-text-color dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                                    {{ cart.cart_items.length }}
                                </span>
                            </a>
                            } @else {
                            @if (headerData.cartIcon.isVisibleOnDesktop && isDesktop()) {
                            <a class="operation-button cart-btn dynamic-quick-icon-background header-cart-indicator dynamic-quick-icon-border-color dynamic-quick-icon-border-radius" [target]="headerData.cartIcon.target" [attr.data-click_action_value]="headerData.cartIcon['data-click_action_value']" [attr.data-click_action_choice]="headerData.cartIcon['data-click_action_choice']">
                                <img class="header-cart-icon header-cart-indicator" [src]="headerData.cartIcon.cartIconSrc" />
                                <span class="cart-count dynamic-cart-count-text-color header-cart-indicator dynamic-cart-count-background dynamic-cart-count-border-color dynamic-cart-count-border-radius">
                                    {{ cart.cart_items.length }}
                                </span>
                            </a>
                            }
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-search-container">
            <base-search-bar [selectedDeviceType]="deviceType()" [headerData]="headerData" (searchProduct$)="searchProduct($event)" [searchInputControl]="searchInputControl" (searchIconClick$)="searchIconClick()" [isFocused]="isSearchOverlay"></base-search-bar>
        </div>
    </div>
</section>